// import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import SplashScreen from './components/SplashScreen';
import AccountTypeSelection from './components/AccountTypeSelection';
import Registration from './components/Registration';
import Login from './components/Login';
import EmailVerification from './components/EmailVerification';
import HomePage from './components/HomePage';
import PitchCreation from './components/PitchCreation';
import PitchDetailPage from './components/PitchDetailPage';
import RoadmapPage from './components/RoadmapPage';
import FundedPage from './components/FundedPage';
import ProfilePage from './components/ProfilePage';
import UserManagement from './components/UserManagement';
import FundingManagement from './components/FundingManagement';
import TermsManagement from './components/TermsManagement';
import FAQManagement from './components/FAQManagement';
import AboutManagement from './components/AboutManagement';
import PrivacyPolicy from './components/PrivacyPolicy';
import FAQ from './components/FAQ';
import About from './components/About';
import ProtectedRoute from './components/ProtectedRoute';

function AppContent() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <SplashScreen />;
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<SplashScreen />} />
        <Route path="/account-type" element={<AccountTypeSelection />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify-email" element={<EmailVerification />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  // If user is not verified, only allow access to verification page
  if (!user.isEmailVerified) {
    return (
      <Routes>
        <Route path="/verify-email" element={<EmailVerification />} />
        <Route path="*" element={<Navigate to="/verify-email" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/pitch" element={
        <ProtectedRoute accountType="founder">
          <PitchCreation />
        </ProtectedRoute>
      } />
      <Route path="/pitch/:pitchId" element={<PitchDetailPage />} />
      <Route path="/roadmap" element={
        <ProtectedRoute accountType="founder">
          <RoadmapPage />
        </ProtectedRoute>
      } />
      <Route path="/funded" element={<FundedPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/admin/users" element={
        <ProtectedRoute accountType="owner">
          <UserManagement />
        </ProtectedRoute>
      } />
      <Route path="/admin/funding" element={
        <ProtectedRoute accountType="owner">
          <FundingManagement />
        </ProtectedRoute>
      } />
      <Route path="/terms" element={
        <ProtectedRoute accountType="owner">
          <TermsManagement />
        </ProtectedRoute>
      } />
      <Route path="/admin/faq" element={
        <ProtectedRoute accountType="owner">
          <FAQManagement />
        </ProtectedRoute>
      } />
      <Route path="/admin/about" element={
        <ProtectedRoute accountType="owner">
          <AboutManagement />
        </ProtectedRoute>
      } />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/about" element={<About />} />
      <Route path="/verify-email" element={<EmailVerification />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App; 